import NewsList from "./NewsList";
export default NewsList;
